'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _messageEdit = require('./message-edit.html');

var _messageEdit2 = _interopRequireDefault(_messageEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _messageEdit2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    message: '<',
    title: '<',
    onMessageChanged: '&'
  },
  controller: function () {
    function MessageEditComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, MessageEditComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(MessageEditComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.onMessageChanged(this.EventEmitter({
          message: this.message
        }));
      }
    }]);

    return MessageEditComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/dashboard/message-edit/message-edit.component.js